import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { FaWhatsapp } from 'react-icons/fa';
import './MobileHeader.css';
import phoneIcon from './assets/phone.png';

const MobileHeader = () => {
    const { language, switchLanguage, t } = useLanguage();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    // Убрали функцию smoothScrollTo - она больше не нужна

    const handlePhoneClick = () => {
        window.location.href = 'tel:+77073171819';
    };

    const handleWhatsAppClick = () => {
        const whatsappUrl = `https://wa.me/77073171819?text=${encodeURIComponent(t('whatsappMessage'))}`;
        window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    // Убрали функцию toggleLanguage - она больше не нужна

    return (
        <>
            {/* Мобильный хедер */}
            <div className="mobile-header">
                <button className="burger-menu" onClick={toggleMobileMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                <div className="mobile-logo">AI-SON</div>

                <div className="mobile-actions">
                    <button className="whatsapp-icon" onClick={handleWhatsAppClick}>
                        <FaWhatsapp />
                    </button>
                    <button className="phone-icon" onClick={handlePhoneClick}>
                        <img src={phoneIcon} alt="Phone" />
                    </button>
                </div>
            </div>

            {/* Мобильное меню */}
            <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
                <div className="mobile-language-switcher">
                    <div className="language-toggle-container">
                        <button
                            className={`lang-btn ${language === 'ru' ? 'active' : ''}`}
                            onClick={() => switchLanguage('ru')}
                        >
                            Рус
                        </button>
                        <button
                            className={`lang-btn ${language === 'kz' ? 'active' : ''}`}
                            onClick={() => switchLanguage('kz')}
                        >
                            ҚАЗ
                        </button>
                        <div className={`language-slider ${language === 'kz' ? 'slide-right' : 'slide-left'}`}></div>
                    </div>
                </div>

                <div className="mobile-contact-info">
                    <div className="mobile-phone" onClick={handlePhoneClick}>
                        <span className="phone-number">+7 707 317 18 19</span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MobileHeader;
